import React from 'react';
import { TrendingUpIcon, ExternalLinkIcon, CheckCircleIcon } from 'lucide-react';
const TelecomsIndustryMovement = () => {
  return <section className="py-16 bg-white border-t border-gray-200" data-id="element-458">
      <div className="container mx-auto px-4" data-id="element-459">
        <div className="max-w-4xl mx-auto" data-id="element-460">
          <div className="text-center mb-12" data-id="element-461">
            <div className="inline-block p-4 bg-[#e5f8f7] rounded-full mb-4" data-id="element-462">
              <TrendingUpIcon className="h-12 w-12 text-[#54d4cb]" data-id="element-463" />
            </div>
            <h2 className="text-3xl font-bold mb-4" data-id="element-464">
              Major MNOs Are Already Moving
            </h2>
            <p className="text-xl text-gray-600" data-id="element-465">
              Leading mobile network operators recognize the opportunity and are
              launching AI services for their subscribers
            </p>
          </div>
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-lg shadow-lg p-8 mb-8 border-2 border-[#54d4cb]" data-id="element-466">
            <div className="flex items-start mb-6" data-id="element-467">
              <div className="flex-shrink-0 mr-4" data-id="element-468">
                <div className="bg-[#54d4cb] rounded-full p-3" data-id="element-469">
                  <CheckCircleIcon className="h-8 w-8 text-white" data-id="element-470" />
                </div>
              </div>
              <div className="flex-1" data-id="element-471">
                <h3 className="text-2xl font-bold mb-2 text-[#2d8a84]" data-id="element-472">
                  Africell Launches AfriGPT
                </h3>
                <p className="text-lg text-gray-700 mb-4" data-id="element-473">
                  Africell, a major mobile network operator across Africa, has
                  launched <span className="font-semibold" data-id="element-474">AfriGPT</span> —
                  bringing AI capabilities directly to their subscribers through
                  accessible channels.
                </p>
                <p className="text-gray-700 mb-4" data-id="element-475">
                  This pioneering move demonstrates that telecom operators are
                  recognizing AI as a critical service offering for their
                  customer base, validating the market opportunity for AI-on-SMS
                  solutions.
                </p>
                <a href="https://www.africell.ao/en/afrigpt-en/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#54d4cb] hover:text-[#3ba69f] font-semibold text-lg" data-id="element-476">
                  Learn more about AfriGPT
                  <ExternalLinkIcon className="h-5 w-5 ml-2" data-id="element-477" />
                </a>
              </div>
            </div>
          </div>
          <div className="bg-[#e5f8f7] rounded-lg p-8" data-id="element-478">
            <h3 className="text-xl font-semibold mb-4 text-center text-[#2d8a84]" data-id="element-479">
              The Opportunity Is Now
            </h3>
            <p className="text-lg text-gray-700 text-center mb-6" data-id="element-480">
              As more operators enter this space, early movers will establish
              market leadership and capture the growing demand for accessible AI
              services. Partner with us to launch your branded AI offering and
              join the operators leading this transformation.
            </p>
            <div className="text-center" data-id="element-481">
              <a href="https://calendly.com/es-lee/intro?referrer=voxiesite" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#54d4cb] text-white px-8 py-4 rounded-md font-semibold text-lg hover:bg-[#43aca5] transition-colors shadow-md" data-id="element-482">
                Discuss Your AI Strategy
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default TelecomsIndustryMovement;